import { useMutation, useQuery } from "@tanstack/react-query";
import localStorageKey from "../../../enumerations/localStorageKey";
import queryKey from "../../../enumerations/queryKey";
import { getWinCategory } from "../../../hooks/winBet/service";
import { envChangeType, envType } from "../../../plugins/utils";
import {
  apiGetAesexyGameLoginUrl,
  apiGetAgGameLoginUrl,
  apiGetAgTrialGameUrl,
  apiGetOmgGameLoginUrl,
  apiGetOmgDemoGames,
  apiGetOmgDemoGameUrl,
  apiGetCQ9GameLoginUrl,
  apiGetCRSPORTGameLoginUrl,
  apiGetEvoplayGameLoginUrl,
  apiGetFBSPORTGameLoginUrl,
  apiGetFCFishGameLoginUrl,
  apiGetFCGameLoginUrl,
  apiGetFFFLiveGameLoginUrl,
  apiGetGameCategoryV2,
  apiGetGameV2,
  apiGetHotGameV2,
  apiGetJDBFishGameLoginUrl,
  apiGetJDBSlotGameLoginUrl,
  apiGetJiliGameLoginUrl,
  apiGetJollySportGameLoginUrl,
  apiGetLuckySportGameLoginUrl,
  apiGetMgGameLoginUrl,
  apiGetMiniGameGameLoginUrl,
  apiGetONEEVOLIVEGameLoginUrl,
  apiGetONEGLOBALGameLoginUrl,
  apiGetONEHACKSAWGameLoginUrl,
  apiGetONEJDBFISHGameLoginUrl,
  apiGetONEJDBSLOTGameLoginUrl,
  apiGetONEJILICARDGameLoginUrl,
  apiGetONEJILICASINOGameLoginUrl,
  apiGetONEJILIFISHGameLoginUrl,
  apiGetONEJILISLOTGameLoginUrl,
  apiGetONEPGGameLoginUrl,
  apiGetONEPPGameLoginUrl,
  apiGetONEPPLIVEGameLoginUrl,
  apiGetONESABAGameLoginUrl,
  apiGetPPLiveGameLoginUrl,
  apiGetPTGameLoginUrl,
  apiGetPgGameLoginUrl,
  apiGetPlayStarGameLoginUrl,
  apiGetPpGameLoginUrl,
  apiGetSBOSPORTGameLoginUrl,
  apiGetSpribeGameLoginUrl,
  apiGetSpribeoneGameLoginUrl,
  apiGetT1LoginUrl,
  apiGetTcgGameLoginUrl,
  apiGetViaCasinoLiveGameLoginUrl,
  apiGetWCFGameLoginUrl,
  apiGetWeblockchainGameLoginUrl,
  apiGetWefishGameLoginUrl,
  apiGetWeliveGameLoginUrl,
  apiGetWelotteryGameLoginUrl,
  apiGetWeslotGameLoginUrl,
  apiGetWesportGameLoginUrl,
  apiGetYbslotGameLoginUrl,
  apiGetYggGameLoginUrl,
  apiGetYoubetGameLoginUrl,
  getAesexyGameList,
  getAgGameList,
  getOmgGameList,
  getCQ9GameList,
  getCRSPORTGameList,
  getEvoGameUrl,
  getEvoplayGameList,
  getFBSPORTGameList,
  getFCFishGameList,
  getFCGameList,
  getFFFLiveGameList,
  getJDBFishGameList,
  getJDBSlotGameList,
  getJiliGameList,
  getLuckySportGameList,
  getMiniGameGameList,
  getONEEVOLIVEGameList,
  getONEGLOBALGameList,
  getONEHACKSAWHGameList,
  getONEJDBFISHGameList,
  getONEJDBSLOTGameList,
  getONEJILICARDGameList,
  getONEJILICASINOGameList,
  getONEJILIFISHGameList,
  getONEJILISLOTGameList,
  getONEPGGameList,
  getONEPPGameList,
  getONEPPLIVEGameList,
  getONESABAGameList,
  getPPLIveGameList,
  getPTGameList,
  getPgGameList,
  getPlayStarGameList,
  getPpGameList,
  getSBOSPORTGameList,
  getSpribeGameList,
  getSpribeoneGameList,
  getT1GameList,
  getTcgGameList,
  getViaCasinoLiveGameList,
  getWCFGameList,
  getWeblockchainGameList,
  getWefishGameList,
  getWeliveGameList,
  getWelotteryGameList,
  getWeslotGameList,
  getWesportGameList,
  getYbslotGameList,
  getYggGameList,
  getYoubetGameList,
} from "../service";

export const useGetWinGameList = (options) => {
  return useQuery(
    [queryKey.HOME_1BBET_WIN_GAME],
    () =>
      getWinCategory().then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) =>
          result.push({ code: item.game_category_detail_type, name: item.name }),
        );
        return result;
      }),
    {
      ...options,
    },
  );
};

export const useGetMgGameLoginLink = (params, options) => {
  return useQuery(
    [queryKey.MG_GAME_LINK],
    () =>
      apiGetMgGameLoginUrl(params).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      enabled: false,
      ...options,
    },
  );
};

export const useGetT1GameLoginLink = () => {
  return useMutation(
    ({ params, query }) => apiGetT1LoginUrl(params, query).then((res) => res.data.data),
    {
      onSuccess: () => {},
    },
  );
};

export const useGetT1GameList = (options) => {
  return useQuery(
    [queryKey.T1_GAME_LIST],
    () =>
      getT1GameList().then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ code: item.game_code, name: item.name }));
        return result;
      }),
    {
      ...options,
    },
  );
};

export const useGetEvoGameLoginLink = () => {
  return useMutation(
    ({ params, query }) => getEvoGameUrl(params, query).then((res) => res.data.data),
    {
      onSuccess: () => {},
    },
  );
};

export const useGetPpGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.PP_GAME_LINK],
    ({ params, query }) =>
      apiGetPpGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};

export const useGetPpGameList = (options) => {
  return useQuery(
    [queryKey.PP_GAME_LIST],
    () =>
      getPpGameList().then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ code: item.game_code, name: item.name }));
        return result;
      }),
    {
      ...options,
    },
  );
};
//pg
export const useGetPgGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.PG_GAME_LINK],
    ({ params, query }) =>
      apiGetPgGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetPgGameList = (options) => {
  return useQuery(
    [queryKey.PG_GAME_LIST],
    () =>
      getPgGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//ygg
export const useGetYggGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.YGG_GAME_LINK],
    ({ params, query }) =>
      apiGetYggGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetYggGameList = (options) => {
  return useQuery(
    [queryKey.YGG_GAME_LIST],
    () =>
      getYggGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//evoplay
export const useGetEvoplayGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.EVOPLAY_GAME_LINK],
    ({ params, query }) =>
      apiGetEvoplayGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetEvoplayGameList = (options) => {
  return useQuery(
    [queryKey.EVOPLAY_GAME_LIST],
    () =>
      getEvoplayGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//jili
export const useGetJiliGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.JILI_GAME_LINK],
    ({ params, query }) =>
      apiGetJiliGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetJiliGameList = (options) => {
  return useQuery(
    [queryKey.JILI_GAME_LIST],
    () =>
      getJiliGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//spribe
export const useGetSpribeGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.SPRIBE_GAME_LINK],
    ({ params, query }) =>
      apiGetSpribeGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetSpribeGameList = (options) => {
  return useQuery(
    [queryKey.SPRIBE_GAME_LIST],
    () =>
      getSpribeGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//PT
export const useGetPTGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.PT_GAME_LINK],
    ({ params, query }) =>
      apiGetPTGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetPTGameList = (options) => {
  return useQuery(
    [queryKey.PT_GAME_LIST],
    () =>
      getPTGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//PPLive
export const useGetPPLiveGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.PPLIVE_GAME_LINK],
    ({ params, query }) =>
      apiGetPPLiveGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetPPLiveGameList = (options) => {
  return useQuery(
    [queryKey.PPLIVE_GAME_LIST],
    () =>
      getPPLIveGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//FC
export const useGetFCGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.FC_GAME_LINK],
    ({ params, query }) =>
      apiGetFCGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetFCGameList = (options) => {
  return useQuery(
    [queryKey.FC_GAME_LIST],
    () =>
      getFCGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//CQ9
export const useGetCQ9GameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.CQ9_GAME_LINK],
    ({ params, query }) =>
      apiGetCQ9GameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    {
      ...options,
    },
  );
};
export const useGetCQ9GameList = (options) => {
  return useQuery(
    [queryKey.CQ9_GAME_LIST],
    () =>
      getCQ9GameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    {
      ...options,
    },
  );
};

//PLAY STAR
export const useGetPlayStarGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.PLAYSTAR_GAME_LINK],
    ({ params, query }) =>
      apiGetPlayStarGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetPlayStarGameList = (options) => {
  return useQuery(
    [queryKey.PLAYSTAR_GAME_LIST],
    () =>
      getPlayStarGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetWeblockchainGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.WEBLOCKCHAIN_GAME_LINK],
    ({ params, query }) =>
      apiGetWeblockchainGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetWeblockchainGameList = (options) => {
  return useQuery(
    [queryKey.WEBLOCKCHAIN_GAME_LIST],
    () =>
      getWeblockchainGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetWelotteryGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.WELOTTERY_GAME_LINK],
    ({ params, query }) =>
      apiGetWelotteryGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetWelotteryGameList = (options) => {
  return useQuery(
    [queryKey.WELOTTERY_GAME_LIST],
    () =>
      getWelotteryGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetWeliveGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.WELIVE_GAME_LINK],
    ({ params, query }) =>
      apiGetWeliveGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetWeliveGameList = (options) => {
  return useQuery(
    [queryKey.WELIVE_GAME_LIST],
    () =>
      getWeliveGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetTcgGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.TCG_GAME_LINK],
    ({ params, query }) =>
      apiGetTcgGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetTcgGameList = (options) => {
  return useQuery(
    [queryKey.TCG_GAME_LIST],
    () =>
      getTcgGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetYoubetGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.YOUBET_GAME_LINK],
    ({ params, query }) =>
      apiGetYoubetGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetYoubetGameList = (options) => {
  return useQuery(
    [queryKey.YOUBET_GAME_LIST],
    () =>
      getYoubetGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetAesexyGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.AESEXY_GAME_LINK],
    ({ params, query }) =>
      apiGetAesexyGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetAesexyGameList = (options) => {
  return useQuery(
    [queryKey.AESEXY_GAME_LIST],
    () =>
      getAesexyGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetSpribeoneGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.SPRIBEONE_GAME_LINK],
    ({ params, query }) =>
      apiGetSpribeoneGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetSpribeoneGameList = (options) => {
  return useQuery(
    [queryKey.SPRIBEONE_GAME_LIST],
    () =>
      getSpribeoneGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetWesportGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.WESPORT_GAME_LINK],
    ({ params, query }) =>
      apiGetWesportGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetWesportGameList = (options) => {
  return useQuery(
    [queryKey.WESPORT_GAME_LIST],
    () =>
      getWesportGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};
export const useGetLuckySportGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.LUCKYSPORT_GAME_LINK],
    ({ params, query }) =>
      apiGetLuckySportGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetLuckySportGameList = (options) => {
  return useQuery(
    [queryKey.LUCKYSPORT_GAME_LIST],
    () =>
      getLuckySportGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetYbslotGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.YBSLOT_GAME_LINK],
    ({ params, query }) =>
      apiGetYbslotGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetYbslotGameList = (options) => {
  return useQuery(
    [queryKey.YBSLOT_GAME_LIST],
    () =>
      getYbslotGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetWefishGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.WEFISH_GAME_LINK],
    ({ params, query }) =>
      apiGetWefishGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetWefishGameList = (options) => {
  return useQuery(
    [queryKey.WEFISH_GAME_LIST],
    () =>
      getWefishGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetWeslotGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.WESLOT_GAME_LINK],
    ({ params, query }) =>
      apiGetWeslotGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetWeslotGameList = (options) => {
  return useQuery(
    [queryKey.WESLOT_GAME_LIST],
    () =>
      getWeslotGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetFCFishGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.FCFISH_GAME_LINK],
    ({ params, query }) =>
      apiGetFCFishGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data?.gameUrl;
        return _result;
      }),
    { ...options },
  );
};
export const useGetFCFishGameList = (options) => {
  return useQuery(
    [queryKey.FCFISH_GAME_LIST],
    () =>
      getFCFishGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetJDBFishGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.JDBFISH_GAME_LINK],
    ({ params, query }) =>
      apiGetJDBFishGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data?.gameUrl;
        return _result;
      }),
    { ...options },
  );
};
export const useGetJDBFishGameList = (options) => {
  return useQuery(
    [queryKey.JDBFISH_GAME_LIST],
    () =>
      getJDBFishGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetJDBSlotGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.JDBSLOT_GAME_LINK],
    ({ params, query }) =>
      apiGetJDBSlotGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data?.gameUrl;
        return _result;
      }),
    { ...options },
  );
};
export const useGetJDBSlotGameList = (options) => {
  return useQuery(
    [queryKey.JDBSLOT_GAME_LIST],
    () =>
      getJDBSlotGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetViaCasinoLiveGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.VIACASINOLIVE_GAME_LINK],
    ({ params, query }) =>
      apiGetViaCasinoLiveGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetViaCasinoLiveGameList = (options) => {
  return useQuery(
    [queryKey.VIACASINOLIVE_GAME_LIST],
    () =>
      getViaCasinoLiveGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetFFFLiveGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.FFFLIVE_GAME_LINK],
    ({ params, query }) =>
      apiGetFFFLiveGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetFFFLiveGameList = (options) => {
  return useQuery(
    [queryKey.FFFLIVE_GAME_LIST],
    () =>
      getFFFLiveGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetWCFGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.WCF_GAME_LINK],
    ({ params, query }) =>
      apiGetWCFGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetWCFGameList = (options) => {
  return useQuery(
    [queryKey.WCF_GAME_LIST],
    () =>
      getWCFGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetJollySportGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.JOLLYSPORT_GAME_LINK],
    ({ params, query }) =>
      apiGetJollySportGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};

export const useGetONEJDBSLOTGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEJDBSLOT_GAME_LINK],
    ({ params, query }) =>
      apiGetONEJDBSLOTGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEJDBSLOTGameList = (options) => {
  return useQuery(
    [queryKey.ONEJDBSLOT_GAME_LIST],
    () =>
      getONEJDBSLOTGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEJDBFISHGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEJDBFISH_GAME_LINK],
    ({ params, query }) =>
      apiGetONEJDBFISHGameLoginUrl(params, query).then((res) => {
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEJDBFISHGameList = (options) => {
  return useQuery(
    [queryKey.ONEJDBFISH_GAME_LIST],
    () =>
      getONEJDBFISHGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEPPGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEPP_GAME_LINK],
    ({ params, query }) =>
      apiGetONEPPGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEPPGameList = (options) => {
  return useQuery(
    [queryKey.ONEPP_GAME_LIST],
    () =>
      getONEPPGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEPGGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEPG_GAME_LINK],
    ({ params, query }) =>
      apiGetONEPGGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEPGGameList = (options) => {
  return useQuery(
    [queryKey.ONEPG_GAME_LIST],
    () =>
      getONEPGGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEHACKSAWGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEHACKSAW_GAME_LINK],
    ({ params, query }) =>
      apiGetONEHACKSAWGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEHACKSAWGameList = (options) => {
  return useQuery(
    [queryKey.ONEHACKSAW_GAME_LIST],
    () =>
      getONEHACKSAWHGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEJILISLOTGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEJILISLOT_GAME_LINK],
    ({ params, query }) =>
      apiGetONEJILISLOTGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEJILISLOTGameList = (options) => {
  return useQuery(
    [queryKey.ONEJILISLOT_GAME_LIST],
    () =>
      getONEJILISLOTGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEJILIFISHGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEJILIFISH_GAME_LINK],
    ({ params, query }) =>
      apiGetONEJILIFISHGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEJILIFISHGameList = (options) => {
  return useQuery(
    [queryKey.ONEJILIFISH_GAME_LIST],
    () =>
      getONEJILIFISHGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};
export const useGetONEJILICARDGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEJILICARD_GAME_LINK],
    ({ params, query }) =>
      apiGetONEJILICARDGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEJILICARDGameList = (options) => {
  return useQuery(
    [queryKey.ONEJILICARD_GAME_LIST],
    () =>
      getONEJILICARDGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEJILICASINOGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEJILICASINO_GAME_LINK],
    ({ params, query }) =>
      apiGetONEJILICASINOGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEJILICASINOGameList = (options) => {
  return useQuery(
    [queryKey.ONEJILICASINO_GAME_LIST],
    () =>
      getONEJILICASINOGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEEVOLIVEGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEEVOLIVE_GAME_LINK],
    ({ params, query }) =>
      apiGetONEEVOLIVEGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEEVOLIVEGameList = (options) => {
  return useQuery(
    [queryKey.ONEEVOLIVE_GAME_LIST],
    () =>
      getONEEVOLIVEGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEPPLIVEGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONEPPLIVE_GAME_LINK],
    ({ params, query }) =>
      apiGetONEPPLIVEGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEPPLIVEGameList = (options) => {
  return useQuery(
    [queryKey.ONEPPLIVE_GAME_LIST],
    () =>
      getONEPPLIVEGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONESABAGameLoginLink = (options) => {
  return useMutation(
    [queryKey.ONESABA_GAME_LINK],
    ({ params, query }) =>
      apiGetONESABAGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONESABAGameList = (options) => {
  return useQuery(
    [queryKey.ONESABA_GAME_LIST],
    () =>
      getONESABAGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetONEGLOBALGameLoginLink = (options) => {
  return useMutation(
    ({ params, query }) =>
      apiGetONEGLOBALGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetONEGLOBALGameList = (options) => {
  return useQuery(
    [queryKey.ONEGLOBAL_GAME_LIST],
    () =>
      getONEGLOBALGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetAgGameLoginLink = (options) => {
  return useMutation(
    [queryKey.AG_GAME_LINK],
    ({ params, query }) =>
      apiGetAgGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
// AG 試玩：後端回傳的 trial_player_id 存在 localStorage，下次帶回去沿用同一個試玩帳號與餘額
// 後端過期 (預設 2 小時沒玩) 會自動換新帳號
export const useGetAgTrialGameLink = (options) => {
  return useMutation(
    [queryKey.AG_TRIAL_GAME_LINK],
    async ({ gameId, lang }) => {
      let res;
      try {
        res = await apiGetAgTrialGameUrl({
          game_id: String(gameId),
          lang,
          trial_player_id: localStorage.getItem(localStorageKey.AG_TRIAL_PLAYER_ID) || undefined,
        });
      } catch (e) {
        const status = e?.response?.status;
        const result = e?.response?.data?.result;
        // 後端未開放試玩，交給呼叫端改走登入
        if (status === 400 && result?.code === 6660004) {
          const error = new Error("AG_TRIAL_NOT_SUPPORTED");
          error.notSupported = true;
          throw error;
        }
        throw result?.message ?? e?.response?.data?.message ?? e?.message;
      }
      const data = res.data?.data;
      if (!data?.gameUrl) throw res.data?.result?.message;
      if (data.trial_player_id) {
        localStorage.setItem(localStorageKey.AG_TRIAL_PLAYER_ID, data.trial_player_id);
      }
      return data.gameUrl;
    },
    { ...options },
  );
};
export const useGetAgGameList = (options) => {
  return useQuery(
    [queryKey.AG_GAME_LIST],
    () =>
      getAgGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetOmgGameLoginLink = (options) => {
  return useMutation(
    [queryKey.OMG_GAME_LINK],
    ({ params, query }) =>
      apiGetOmgGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
// OMG 試玩 token 與可試玩的遊戲清單，同一段時間內共用，不用每次點都重抓
const OMG_DEMO_CACHE_TTL = 5 * 60 * 1000;
let omgDemoCache = null;

const getOmgDemoInfo = async () => {
  if (omgDemoCache && Date.now() - omgDemoCache.fetchedAt < OMG_DEMO_CACHE_TTL) {
    return omgDemoCache;
  }
  const res = await apiGetOmgDemoGames();
  if (res.data?.code !== 0) throw res.data?.msg;
  const { token, app_id: appId, games = [] } = res.data.data;
  omgDemoCache = {
    token,
    appId,
    gameIds: new Set(games.map((game) => String(game.id))),
    fetchedAt: Date.now(),
  };
  return omgDemoCache;
};

// 前端語系代碼轉 OMG 語系代碼，對不上的一律英文
const OMG_DEMO_LANG_MAP = { cn: "zh", vn: "vi", kr: "ko", jp: "ja", in: "hi", pk: "ur", my: "ms" };
const OMG_DEMO_LANGS = ["en", "zh", "vi", "ko", "ja", "hi", "ur", "ms", "bn", "es", "id", "pt", "th"];
const transferOmgDemoLang = (lang) => {
  const _lang = OMG_DEMO_LANG_MAP[lang] ?? lang;
  return OMG_DEMO_LANGS.includes(_lang) ? _lang : "en";
};

export const useGetOmgDemoGameLink = (options) => {
  return useMutation(
    [queryKey.OMG_DEMO_GAME_LINK],
    async ({ gameId, lang }) => {
      const { token, appId, gameIds } = await getOmgDemoInfo();
      // 不在試玩清單的遊戲，OMG 開不出來，交給呼叫端改走登入
      if (!gameIds.has(String(gameId))) {
        const error = new Error("OMG_DEMO_NOT_SUPPORTED");
        error.notSupported = true;
        throw error;
      }
      const res = await apiGetOmgDemoGameUrl({
        gameid: String(gameId),
        lang: transferOmgDemoLang(lang),
        nick: String(gameId),
        appid: String(appId),
        token,
      });
      if (res.data?.code !== 0 || !res.data?.data?.gameurl) {
        // token 可能失效，下次重抓
        omgDemoCache = null;
        throw res.data?.msg;
      }
      return res.data.data.gameurl;
    },
    { ...options },
  );
};

export const useGetOmgGameList = (options) => {
  return useQuery(
    [queryKey.OMG_GAME_LIST],
    () =>
      getOmgGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetSBOSPORTGameLoginLink = (options) => {
  return useMutation(
    [queryKey.SBOSPORT_GAME_LINK],
    ({ params, query }) =>
      apiGetSBOSPORTGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetSBOSPORTGameList = (options) => {
  return useQuery(
    [queryKey.SBOSPORT_GAME_LIST],
    () =>
      getSBOSPORTGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetCRSPORTGameLoginLink = (options) => {
  return useMutation(
    [queryKey.CRSPORT_GAME_LINK],
    ({ params, query }) =>
      apiGetCRSPORTGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetCRSPORTGameList = (options) => {
  return useQuery(
    [queryKey.CRSPORT_GAME_LIST],
    () =>
      getCRSPORTGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetFBSPORTGameLoginLink = (options) => {
  return useMutation(
    [queryKey.FBSPORT_GAME_LINK],
    ({ params, query }) =>
      apiGetFBSPORTGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetFBSPORTGameList = (options) => {
  return useQuery(
    [queryKey.FBSPORT_GAME_LIST],
    () =>
      getFBSPORTGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

export const useGetMiniGameGameLoginLink = (params, options) => {
  return useMutation(
    [queryKey.MINIGAME_GAME_LINK],
    ({ params, query }) =>
      apiGetMiniGameGameLoginUrl(params, query).then((res) => {
        console.debug("res", res);
        const _result = res.data.data;
        return _result;
      }),
    { ...options },
  );
};
export const useGetMiniGameGameList = (options) => {
  return useQuery(
    [queryKey.MINIGAME_GAME_LIST],
    () =>
      getMiniGameGameList({ page_size: 0 }).then((res) => {
        const _result = res.data.data;
        const result = [];
        _result?.map((item) => result.push({ ...item, code: item.id }));
        return result;
      }),
    { ...options },
  );
};

//1bbetv2
export const useGetGameCategoryV2 = (options, params) => {
  return useQuery(
    [queryKey.HOME_GAME_CATEGORY],
    () =>
      apiGetGameCategoryV2().then((res) => {
        const categories = res.data.data
          .filter(
            (data) =>
              data.game_3th.length > 0 &&
              !params?.excludedCategories.includes(data.game_category_code),
          )
          .map((category) => {
            if (envChangeType("REACT_APP_OPEN_SABA_CRICKET", envType.BOOLEAN) === false)
              return category;
            if (category.game_category_code === "sport") {
              const sabaIndex = category.game_3th.findIndex(
                (_sport) => _sport.game_3th_code === "saba",
              );
              if (sabaIndex >= 0) {
                return {
                  ...category,
                  game_3th: [
                    ...category.game_3th.slice(0, sabaIndex + 1),
                    {
                      ...category.game_3th[sabaIndex],
                      game_3th_code: "sabacricket",
                      sorting: category.game_3th[sabaIndex].sorting + 1,
                    },
                    ...category.game_3th.slice(sabaIndex + 1, category.game_3th.length),
                  ],
                };
              }
            }
            return category;
          });
        return categories;
        // return res.data.data.filter(
        //   (data) =>
        //     data.game_3th.length > 0 &&
        //     !params?.excludedCategories.includes(data.game_category_code),
        // );
      }),
    {
      ...options,
    },
  );
};

export const useGetHotGameV2 = (options, params) => {
  return useQuery(
    [queryKey.HOT_GAME],
    () =>
      apiGetHotGameV2(params).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

const WORLD_CUP_CATEGORY = {
  game_category_id: 2026,
  game_category_code: "fifa",
  game_category_name: "Fifa Worldcup",
  sorting: -1,
  game_3th: [
    {
      game_3th_id: 999,
      game_3th_code: "fbworldcup",
      is_new: 0,
      is_hot: 1,
      sorting: 1,
      maintenance_status: 0,
      allow_test_account: 1,
    },
  ],
};

export const useGetGameV2 = (options, params) => {
  return useQuery(
    [queryKey.ALL_GAME],
    () =>
      apiGetGameV2({
        ...params,
        showNum: envChangeType("REACT_APP_HOT_GAMES_COUNT", envType.NUMBER),
      }).then((res) => {
        let isHaveFB = false;
        const category = res.data.data.category_list
          .filter(
            (data) =>
              data.game_3th.length > 0 &&
              !params?.excludedCategories.includes(data.game_category_code),
          )
          .map((category) => {
            if (category.game_category_code === "sport") {
              const fbObject = category.game_3th.find(
                (_sport) => _sport.game_3th_code === "fbsport",
              );
              isHaveFB = !!fbObject && fbObject.maintenance_status === 0;
            }
            if (envChangeType("REACT_APP_OPEN_SABA_CRICKET", envType.BOOLEAN) === true) {
              if (category.game_category_code === "sport") {
                const sabaIndex = category.game_3th.findIndex(
                  (_sport) => _sport.game_3th_code === "saba",
                );

                if (sabaIndex >= 0) {
                  return {
                    ...category,
                    game_3th: [
                      ...category.game_3th.slice(0, sabaIndex + 1),
                      {
                        ...category.game_3th[sabaIndex],
                        game_3th_code: "sabacricket",
                        sorting: category.game_3th[sabaIndex].sorting + 1,
                      },
                      ...category.game_3th.slice(sabaIndex + 1, category.game_3th.length),
                    ],
                  };
                }
              }
              return category;
            }
            return category;
          });
        const hot = res.data.data.hot_list;
        return {
          hot_list: hot,
          category_list:
            envChangeType("REACT_APP_WORLDCUP_IFRAME") && isHaveFB === true
              ? [WORLD_CUP_CATEGORY, ...category]
              : category,
        };
      }),
    {
      staleTime: 10 * (60 * 1000), //10mins
      cacheTime: 10 * (60 * 1000), //10mins
      ...options,
    },
  );
};
